document.addEventListener('DOMContentLoaded', function () {
  var root = document.querySelector('.cr-story');
  if (!root) return;

  var stickyBar = root.querySelector('[data-cr-sticky-bar]');
  if (stickyBar) {
    var heroEl = root.querySelector('.cr-hero');
    var showStickyBar = function () {
      var triggerPoint = heroEl ? heroEl.getBoundingClientRect().bottom + window.scrollY : window.innerHeight;
      if (window.scrollY > triggerPoint) {
        stickyBar.classList.add('is-visible');
      } else {
        stickyBar.classList.remove('is-visible');
      }
    };
    window.addEventListener('scroll', showStickyBar, { passive: true });
    showStickyBar();

    var addBtn = stickyBar.querySelector('[data-cr-add-to-cart]');
    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var variantId = addBtn.getAttribute('data-variant-id');
        var productUrl = addBtn.getAttribute('data-product-url');
        var defaultLabel = addBtn.getAttribute('data-label-default');
        addBtn.disabled = true;
        addBtn.textContent = '...';

        fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
          ? window.Shopify.routes.root + 'cart/add.js'
          : '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
        })
          .then(function (res) {
            if (!res.ok) throw new Error('add_to_cart_failed');
            return res.json();
          })
          .then(function () {
            addBtn.textContent = 'Ajouté ✓';
            document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
            document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
            setTimeout(function () {
              addBtn.textContent = defaultLabel;
              addBtn.disabled = false;
            }, 1800);
          })
          .catch(function () {
            if (productUrl) {
              window.location.href = productUrl;
            } else {
              addBtn.textContent = defaultLabel;
              addBtn.disabled = false;
            }
          });
      });
    }
  }

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var revealEls = root.querySelectorAll('.cr-reveal');

  function animateCount(el) {
    if (el.dataset.counted) return;
    el.dataset.counted = '1';

    var target = parseFloat(el.getAttribute('data-count-to'));
    if (isNaN(target)) return;
    var prefix = el.getAttribute('data-count-prefix') || '';
    var suffix = el.getAttribute('data-count-suffix') || '';
    var decimals = el.getAttribute('data-count-decimals') ? parseInt(el.getAttribute('data-count-decimals'), 10) : 0;

    if (reduceMotion) {
      el.textContent = prefix + target.toFixed(decimals) + suffix;
      return;
    }

    var duration = 1400;
    var start = null;

    function step(ts) {
      if (!start) start = ts;
      var progress = Math.min((ts - start) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      var value = target * eased;
      el.textContent = prefix + value.toFixed(decimals) + suffix;
      if (progress < 1) requestAnimationFrame(step);
    }

    requestAnimationFrame(step);
  }

  if (!('IntersectionObserver' in window)) {
    revealEls.forEach(function (el) {
      el.classList.add('is-visible');
      el.querySelectorAll('[data-count-to]').forEach(animateCount);
    });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          entry.target.querySelectorAll('[data-count-to]').forEach(animateCount);
          obs.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.25, rootMargin: '0px 0px -10% 0px' }
  );

  revealEls.forEach(function (el) {
    observer.observe(el);
  });

  var progressBar = document.querySelector('.cr-progress');
  var stages = root.querySelectorAll('.cr-complex-stage');

  var onScroll = function () {
    if (progressBar) {
      var scrollTop = window.scrollY;
      var docHeight = root.offsetHeight - window.innerHeight;
      var pct = docHeight > 0 ? Math.min(Math.max(scrollTop / docHeight, 0), 1) * 100 : 0;
      progressBar.style.width = pct + '%';
    }

    stages.forEach(function (stage) {
      var rect = stage.getBoundingClientRect();
      var total = rect.height - window.innerHeight;
      var scrolled = -rect.top;
      var progress = total > 0 ? Math.min(Math.max(scrolled / total, 0), 1) : 0;
      stage.style.setProperty('--stage-progress', progress);

      if (progress > 0.7) {
        var orbit = stage.querySelector('.cr-complex-orbit');
        if (orbit && !orbit.classList.contains('is-visible')) {
          orbit.classList.add('is-visible');
        }
      }
    });
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
});
